import { customFetch } from '../base';
import { useRecourceFactory } from './useRecourceFactory';

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useResourceAnonymousLazy = useRecourceFactory(customFetch);